import api from "@/api";

// src/services/fileService.js
class FileService {
  upload(formData) {
    // API upload của bạn yêu cầu `files` và `folderName`
    return api.post('/api/images/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  shareFile(fileUrl){
    return api.get(fileUrl, {
      headers: {
        // Header này để vượt qua trang cảnh báo của ngrok
        "ngrok-skip-browser-warning": "true",
      },
      responseType: 'blob'
    });
  }
}

export default new FileService();